/**
 * Frekans gridinden trip / araç istatistikleri.
 * Grafik (freqByHour) ile aynı mantık: saat başına tek frekans değeri.
 */

/** Aynı saatte birden fazla satır varsa (durak tekrarı) saat başına tek satır bırakır. */
export function dedupeFrequencyRowsByHour(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  const byHour = new Map();
  for (const row of rows) {
    if (row?.saat == null) continue;
    const hour = Number(row.saat);
    if (!Number.isFinite(hour)) continue;

    const frekans = Number(row.frekans) || 0;
    const existing = byHour.get(hour);
    if (!existing || frekans >= (Number(existing.frekans) || 0)) {
      byHour.set(hour, { ...row, saat: hour, frekans });
    }
  }

  return [...byHour.values()].sort((a, b) => a.saat - b.saat);
}

/** Saatlik frekans gridinden toplam sefer (grafik ile tutarlı). */
export function sumHourlyTrips(rows) {
  return dedupeFrequencyRowsByHour(rows).reduce(
    (total, item) => total + Math.ceil(Number(item.frekans) || 0),
    0
  );
}

/** Backend sefer listesinden yön bazlı sefer sayısı. */
export function countSeferTripsByDirection(seferler, yon) {
  if (!Array.isArray(seferler) || seferler.length === 0) return null;
  return seferler.filter((s) => s.yon === yon).length;
}

/**
 * Method için trip istatistikleri — frekans gridi (grafik ile aynı kaynak).
 */
export function getMethodTripStats(optimizationData, methodKey) {
  const gidisRows = optimizationData?.gidis?.[methodKey] || [];
  const donusRows = optimizationData?.donus?.[methodKey] || [];
  const outboundTrips = sumHourlyTrips(gidisRows);
  const inboundTrips = sumHourlyTrips(donusRows);

  return {
    outboundTrips,
    inboundTrips,
    totalTrips: outboundTrips + inboundTrips,
  };
}

/** Method araç sayısı — API meta, sefer arac_id, araç planı sırasıyla. */
export function resolveMethodVehicleCount(
  optimizationData,
  methodKey,
  vehiclePlans
) {
  const metaCount = optimizationData?.[methodKey]?.arac_sayisi;
  if (Number(metaCount) > 0) return Number(metaCount);

  const seferler = optimizationData?.seferler?.[methodKey];
  if (Array.isArray(seferler) && seferler.length > 0) {
    const ids = new Set(
      seferler.map((s) => s.arac_id).filter((id) => id != null && id !== "")
    );
    if (ids.size > 0) return ids.size;
  }

  const plans = vehiclePlans?.[methodKey];
  if (Array.isArray(plans) && plans.length > 0) return plans.length;

  return 0;
}
